const InfinityIcon = ({ size = 24, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"/>
  </svg>
);

export const Logo = ({ size = "text-2xl" }: { size?: string }) => {
  const iconSize = size.includes('text-4xl') ? 36 : size.includes('text-3xl') ? 28 : size.includes('text-xl') ? 18 : 22;
  return (
    <div dir="ltr" className={`flex flex-row items-center font-extrabold tracking-tight ${size} cursor-pointer drop-shadow-sm`}>
      <span className="text-white">iraq</span>
      <span className="text-white/80">–</span>
      <span className="text-[#fbbf24] flex flex-row items-center">
        s<InfinityIcon className="inline-block mx-0.5 text-[#fbbf24]" size={iconSize} />q
      </span>
      <span className="text-white/80 font-medium">.com</span>
    </div>
  );
};

export default Logo;
